// suspense types
export const TOGGLE_MENU = "TOGGLE_MENU ";
export const CLOSE_MENU = "CLOSE_MENU ";
